import { render, staticRenderFns } from "./DisciplineConfig.vue?vue&type=template&id=4cd001e2&scoped=true&"
import script from "./DisciplineConfig.vue?vue&type=script&lang=js&"
export * from "./DisciplineConfig.vue?vue&type=script&lang=js&"
import style0 from "./DisciplineConfig.vue?vue&type=style&index=0&id=4cd001e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd001e2",
  null
  
)

export default component.exports